const Auth = () => import(/* webpackChunkName: "auth" */ '@/views/Auth')
const Login = () => import(/* webpackChunkName: "auth" */ '@/views/auth/Login')
const ForgotPassword = () => import(/* webpackChunkName: "auth" */ '@/views/auth/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPassword')

export default [
  {
    path: '/',
    component: Auth,
    meta: {
      requiresGuest: true
    },
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
        meta: {
          title: 'Login'
        }
      },
      {
        path: 'password/forgot',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: {
          title: 'Recuperação de Senha'
        }
      },
      {
        path: 'password/reset/:token',
        name: 'ResetPassword',
        component: ResetPassword,
        meta: {
          title: 'Redefinir Senha'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/auth.js